export default __webpack_public_path__ + "static/media/smile.a953afcc.svg";